import React from 'react';

import { IconButton, Tooltip } from '@mui/material';

import type { Dispatch } from 'react';

import type { GenericTableData, TableActionItemAction } from './types';

export interface ActionListItem {
  id: string;
  tooltipLabel: string;
  /** Required unless `render` is set, which supplies its own visuals. */
  icon?: React.JSX.Element;
  actionCall?: (id: string) => void;
  elementId?: string;
  shouldRender?: (item: GenericTableData) => boolean;
  /**
   * Escape hatch for an action that needs its own stateful control (e.g. a
   * per-row loading/error state a plain icon+actionCall can't express).
   * When set, this renders instead of the standard Tooltip+IconButton — the
   * custom node owns its own tooltip/click handling.
   */
  render?: (item: GenericTableData) => React.ReactNode;
}

interface IGenericTableActionProps<T> {
  item: T;
  dispatch: Dispatch<TableActionItemAction<T>>;
  actions: ActionListItem[];
}

const GenericTableActions = <GenericTableActionsProps extends GenericTableData>({
  item,
  dispatch,
  actions
}: IGenericTableActionProps<GenericTableActionsProps>) => (
  <>
    {actions
      .filter((action) => action.shouldRender?.(item) ?? true)
      .map((action) =>
        action.render ? (
          <React.Fragment key={action.id}>{action.render(item)}</React.Fragment>
        ) : (
          <Tooltip key={action.id} arrow placement="top" title={action.tooltipLabel}>
            <IconButton
              className={`${action.id}-button`}
              id={action.elementId ?? 'table-action-button'}
              onClick={(event) => {
                dispatch({
                  type: 'SELECT_ACTION_ITEM',
                  payload: { item, anchorEl: event.currentTarget, name: action.id }
                });

                if (action.id === 'emailAnalytics') {
                  dispatch({
                    type: 'SELECT_ACTION_ITEM',
                    payload: { item, anchorEl: event.currentTarget, name: 'candidatePool' }
                  });
                }
                action?.actionCall?.(item.id);
              }}
            >
              {action.icon ?? null}
            </IconButton>
          </Tooltip>
        )
      )}
  </>
);

export default GenericTableActions;
